import Ajax from 'js/utils/ajax/ajax.js';

import { ApiUser } from 'src/interfaces/interfaces.generated';

export const createShopUser = (shopId: number, user: ApiUser): Promise<ApiUser> =>
  Ajax.post(`/useradmin/v1/shopuser/${shopId}`, user);
